import React from 'react'
import ErrorFeedback from './ErrorFeedback'
import ExportButton from './ExportButton'
import Header from './Header'
import ModalBuyCollaboration from './ModalBuyCollaboration'
import ModalDelete from './ModalDelete'
import ModalMessageUsage from './ModalMessageUsage'
import ModalSending from './ModalSending'
import Pagination from './Pagination'
import Results from './Results/Results'
import Search from './Search/Search'

import {
  EmptyState,
  Loading,
  MessageNoResult,
  Panel,
  SPACING_40,
  SpacingVertical,
  ToastContainer,
  Tooltip,
} from 'mailup-web-components'

import emptyStateImage from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state-email-list.svg'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { useRecoilValue } from 'recoil'
import { loadingState, pageErrorState, pageState } from './recoil/state/page'
import { resultsState, resultsStateEmptyState } from './recoil/state/results'

import useCollaboration from './useCollaboration'

const MessageList = () => {
  const intl = useIntl()
  const history = useHistory()
  const loading = useRecoilValue(loadingState)
  const results = useRecoilValue(resultsState)
  const isEmptyState = useRecoilValue(resultsStateEmptyState)
  const { error } = useRecoilValue(pageErrorState)
  const { downloadFile, firstLoading } = useRecoilValue(pageState)

  useCollaboration()

  const hasResults = !!results.items.length

  return (
    <>
      <Tooltip />
      <Loading
        open={firstLoading || downloadFile}
        text={
          downloadFile
            ? intl.formatMessage({
                id: 'Load.EmailMessageOverview.DownloadLoading',
              })
            : ''
        }
      />
      <Header />
      <ToastContainer />
      <ModalBuyCollaboration />
      <ModalDelete />
      <ModalSending />
      <ModalMessageUsage />
      <div className="l-container">
        <ErrorFeedback />
        {!error && (
          <>
            <Search />
            <SpacingVertical variant={SPACING_40} />

            {!firstLoading && !isEmptyState && (
              <React.Suspense fallback={null}>
                {hasResults && (
                  <>
                    <Panel>
                      <div className="l-section">
                        <Results />
                      </div>
                      <div className="l-section">
                        <Pagination />
                      </div>
                    </Panel>
                    <div className="l-section">
                      <ExportButton />
                    </div>
                  </>
                )}
                {!hasResults && (
                  <div className="l-section">
                    <MessageNoResult
                      text={`${intl.formatMessage({
                        id: 'Load.SelectEmailMessage.NoSearchResultTitle',
                      })} ${intl.formatMessage({
                        id: 'Load.SelectEmailMessage.NoSearchResultDescription',
                      })}`}
                    />
                  </div>
                )}
              </React.Suspense>
            )}
            {!loading && isEmptyState && (
              <EmptyState
                thumbSrc={emptyStateImage}
                className="c-message-list-empty-state"
                title={intl.formatMessage({
                  id: 'Load.EmailMessageList.EmptyStateTitle',
                })}
                description={intl.formatMessage({
                  id: 'Load.EmailMessageList.EmptyStateDescription',
                })}
                buttonText={intl.formatMessage({
                  id: 'Load.EmailMessageList.EmptyStateButton',
                })}
                onClickButton={() => history.push('/messages/email/new')}
              />
            )}
          </>
        )}
      </div>
    </>
  )
}

export default MessageList
